import axios from 'axios';
import { msalConfig } from '../authConfig';
import { IPublicClientApplication, AccountInfo } from '@azure/msal-browser';
import { getAccessToken } from './TokenService';

const backendBaseUrl = msalConfig.baseUrl;


export async function getPrompts(msalInstance: IPublicClientApplication, account?: AccountInfo) {
    const token = await getAccessToken(msalInstance, account);
    const response = await axios.get(`${backendBaseUrl}api/Prompt`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}

export async function createPrompt(msalInstance: IPublicClientApplication, data: any, account?: AccountInfo) {
    const token = await getAccessToken(msalInstance, account);
    const response = await axios.post(`${backendBaseUrl}api/Prompt`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}

export async function updatePrompt(msalInstance: IPublicClientApplication, id: string | number, data: any, account?: AccountInfo) {
    const token = await getAccessToken(msalInstance, account);
    const response = await axios.put(`${backendBaseUrl}api/Prompt/${id}`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
}
